export const COLORS = {
  bg: '#141414',
  panel: '#1E1E1E',
  border: '#4A4A4A',
  accent: '#8B1E2D',
  highlight: '#C0C0A0',
  text: '#E6E1DA',
  textMuted: '#8B8B7E',
  textDim: '#5A5A52',
  danger: '#ff4444'
};

export const TYPOGRAPHY = {
  fontFamily: '"IBM Plex Mono", "Courier New", monospace',
  fontFamilyDisplay: '"Playfair Display", serif',
  fontFamilyCondensed: '"IBM Plex Condensed", sans-serif'
};

export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  xxl: '24px',
  xxxl: '32px'
};

export const BREAKPOINTS = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px'
};

export const createGlobalStyles = () => `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    background-color: ${COLORS.bg};
    color: ${COLORS.text};
    font-family: ${TYPOGRAPHY.fontFamily};
    line-height: 1.5;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${TYPOGRAPHY.fontFamilyDisplay};
    letter-spacing: -0.02em;
    font-weight: 600;
  }

  h1 { font-size: 32px; line-height: 1.2; }
  h2 { font-size: 24px; line-height: 1.3; }
  h3 { font-size: 18px; line-height: 1.4; }
  h4 { font-size: 16px; line-height: 1.4; }

  button {
    font-family: ${TYPOGRAPHY.fontFamily};
    transition: all 0.15s ease;
  }

  input, textarea, select {
    font-family: ${TYPOGRAPHY.fontFamily};
  }
`;
